import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon_chevron-left",
  "use": "icon_chevron-left-usage",
  "viewBox": "0 0 6 11",
  "content": "<symbol viewBox=\"0 0 6 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon_chevron-left\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M5.86986 0.69453C6.06114 0.931285 6.03899 1.29115 5.82038 1.49831L1.59747 5.5L5.82038 9.50169C6.03899 9.70885 6.06114 10.0687 5.86986 10.3055C5.67857 10.5422 5.34628 10.5662 5.12767 10.3591L2.5828e-07 5.5L5.12767 0.640945C5.34628 0.433785 5.67857 0.457776 5.86986 0.69453Z\" fill=\"black\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol